import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PrinterReferenceService, PrinterService, TmsFormlyService, UserPrinter } from '../../../../app-shared';
import {
  BaseComponent,
  BaseEditFormModalComponent,
  FormService,
  GridModalComponent,
  GridService,
  NotificationService,
} from '../../../../tms-shared';
import { UserPrinterDocument } from '../../models';
import { UserPrinterDocumentService, UserService } from '../../services';

@Component({
  selector: 'app-user-printers-edit-modal',
  templateUrl: './user-printers-edit-modal.component.html',
  styleUrl: './user-printers-edit-modal.component.scss',
})
export class UserPrintersEditModalComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormModalComponent) form: BaseEditFormModalComponent;
  @ViewChild(GridModalComponent) grid: GridModalComponent;

  @Input() id: string;
  @Input() model: UserPrinter;
  @Input() userId: string;

  columnDefs: ColDef[] = [
    ...this.gridService.checkboxRowSelect('documentKey', $localize`DocumentKey`),
    this.gridService.text('documentDescription', $localize`Description`),
  ];

  fields: FormlyFieldConfig[];

  rowData$: Observable<UserPrinterDocument[]>;

  constructor(
    private printerReferenceService: PrinterReferenceService,
    private printerService: PrinterService,
    private userPrinterDocumentService: UserPrinterDocumentService,
    private userService: UserService,
    private gridService: GridService,
    private formService: FormService,
    private formlyService: TmsFormlyService,
    private notificationService: NotificationService,
  ) {
    super();
  }

  ngOnInit() {
    this.getModel();
    this.getFields();
  }

  private getFields() {
    this.fields = [
      this.formlyService.text('printerName', $localize`Printer`),
      this.formlyService.text('printerAddress', $localize`Address`),
    ];
  }

  save() {
    this.formService.beginSave();
    this.userPrinterDocumentService
      .updateUserPrinterDocuments(
        this.id,
        this.grid.grid.selectedRows.map((x: UserPrinterDocument) => x.documentId),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.notificationService.saveSuccess($localize`User Printer Documents`);
          this.getModel();
          this.formService.endSave(false);
        },
        error: () => {
          this.notificationService.saveFail($localize`User Printer Documents`);
          this.formService.endSave(true);
        },
      });
  }

  private getModel() {
    this.rowData$ = this.userPrinterDocumentService.getAllDocuments(this.id);
    this.grid?.grid?.resetEdited();
  }
}
